<template>
  <component
    :is="as"
    ref="rootEl"
    v-tooltip="
      truncated && {
        position: 'bottom',
        label: label,
      }
    "
    class="sb-breadcrumbs__link"
    :aria-disabled="disabled || undefined"
    :aria-current="current"
    tabindex="0"
    :href="isLink ? href : undefined"
    :target="isLink ? target : undefined"
    :to="isRouterLink ? to : undefined"
    :aria-label="!truncated ? label : undefined"
    v-bind="$attrs"
    @click="handleClick($event, itemId)"
    @keydown.enter.space="handleKeyDown($event, itemId)"
  >
    {{ label }}
  </component>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import type { BreadcrumbLinkType } from './types'
import vTooltip from '../../directives/tooltip'

export type SbBreadcrumbLinkProps = {
  itemId: string | number
  as?: BreadcrumbLinkType
  label?: string
  target?: string
  disabled?: boolean
  href?: string
  to?: string | Record<string, unknown> | null
  current?: string
  truncated?: boolean
  disableLinkNavigation?: boolean
}

const props = withDefaults(defineProps<SbBreadcrumbLinkProps>(), {
  as: 'a',
  label: '',
  target: undefined,
  disabled: false,
  href: '',
  to: null,
  current: undefined,
  truncated: false,
  disableLinkNavigation: false,
})

const emit = defineEmits<{
  (e: 'select-item', label: string): void
}>()

const isLink = computed(() => props.as === 'a')
const isRouterLink = computed(() => props.as === 'router-link')

const rootEl = ref<HTMLElement | null>(null)
defineExpose({ ref: rootEl })

function handleItemSelect(
  event: MouseEvent | KeyboardEvent,
  itemId: string | number,
): void {
  if (props.disabled || props.disableLinkNavigation) {
    event.preventDefault()
  }
  if (props.disabled) {
    event.stopPropagation()
    return
  }
  emit('select-item', String(itemId))
}

function handleClick(event: MouseEvent, itemId: string | number): void {
  handleItemSelect(event, itemId)
}

function handleKeyDown(event: KeyboardEvent, itemId: string | number): void {
  handleItemSelect(event, itemId)
}
</script>
